
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/sentry.client.config.ts")
            }
          });